import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]

import { onBeforeUnmount, onMounted } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalHost',
  props: {
    modelValue: { type: Boolean },
    labelledBy: { default: undefined },
    closeOnBackdrop: { type: Boolean, default: true },
    closeOnEscape: { type: Boolean, default: true },
    panelClass: { default: "max-w-md" }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

onMounted(() => {
  window.addEventListener("keydown", closeByEscape)
})

onBeforeUnmount(() => {
  window.removeEventListener("keydown", closeByEscape)
})

function closeByEscape(event: KeyboardEvent): void {
  if (!props.modelValue || !props.closeOnEscape || event.key !== "Escape") return
  close()
}

function closeByBackdrop(): void {
  if (!props.closeOnBackdrop) return
  close()
}

function close(): void {
  emit("update:modelValue", false)
  emit("close")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 p-4 dark:bg-slate-950/70",
          role: "presentation",
          onClick: _withModifiers(closeByBackdrop, ["self"])
        }, [
          _createElementVNode("section", {
            class: _normalizeClass(["w-full rounded-lg border border-slate-200 bg-white shadow-xl dark:border-slate-700 dark:bg-slate-900", __props.panelClass]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": __props.labelledBy
          }, [
            _renderSlot(_ctx.$slots, "default", { close: close })
          ], 10, _hoisted_1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})